<template>
    <div>
        <!-- 超级账号 -->
        <el-radio-group v-if="userAuthTypeCode === 'ROOT'" class="common-el-radio-group" v-model="authTypeCode"
                        @change="getList()">
            <el-radio-button label="PLATFORM">平台</el-radio-button>
            <el-radio-button label="OPERATION">运营方</el-radio-button>
            <el-radio-button label="TRIBE">联盟</el-radio-button>
            <el-radio-button label="CLUB">俱乐部</el-radio-button>
            <el-radio-button label="ROOT">超级账号</el-radio-button>
        </el-radio-group>
        <!-- 运营方 -->
        <el-radio-group v-if="userAuthTypeCode === 'OPERATION'" class="common-el-radio-group" v-model="authTypeCode"
                        @change="getList()">
            <el-radio-button label="OPERATION">运营方</el-radio-button>
            <el-radio-button label="TRIBE">联盟</el-radio-button>
            <el-radio-button label="CLUB">俱乐部</el-radio-button>
        </el-radio-group>
        <div v-show="authTypeCode !== 'ROOT'">
            <el-button type="primary" @click="$refs.add.show = true">新增账号</el-button>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="listUsers.beanList" row-key="id" height="100%">
                <el-table-column label="排序" align="center" type="index"/>
                <el-table-column label="用户账号" width="120" align="center" prop="username"/>
                <el-table-column label="用户ID" align="center" prop="id"/>
                <el-table-column label="是否联盟主" width="120" align="center">
                    <template slot-scope="scope">{{scope.row.tribeOwner?'是':'否'}}</template>
                </el-table-column>
                <el-table-column label="备注" show-overflow-tooltip align="center" prop="remark"/>
                <el-table-column label="联系方式" width="150" align="center" prop="contact">
                    <template slot-scope="scope">{{scope.row.mobileAreaCode}}-{{scope.row.mobileNo}}</template>
                </el-table-column>
                <template v-if="authTypeCode !== 'ROOT'">
                    <el-table-column label="系统权限" width="150" align="center" prop="authSystems">
                        <template slot-scope="scope">
                            <span v-for="(item,index) of scope.row.authSystems"
                                  :key="scope.row.id + item.code">
                                <template v-if="index === 1">/</template>
                                {{item.code}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="信息" align="center">
                        <template slot-scope="scope">
                            <i class="edit-icon el-icon-edit-outline" @click="clickEdit(scope.row)"></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="权限配置" align="center" width="150">
                        <template slot-scope="scope">
                            <i class="edit-icon el-icon-edit-outline" @click="getConfig(scope.row.id)"></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" width="150">
                        <template slot-scope="scope">
                            <el-switch
                                    :value="scope.row.status"
                                    active-text="启用"
                                    inactive-text="停用"
                                    :active-value="1"
                                    :inactive-value="0" @change="changeStatus(scope.row,$event)"/>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="listUsers.total"
                :current-page="currentPage"
                @current-change="getList({page:$event})"/>

        <comp-add-account ref="add" @my-submit="addUser"/>
        <comp-edit-account ref="edit" :info="editInfo" @my-submit="editUser" @my-delete="removeUser"/>
        <comp-access-configuration
                ref="config"
                :info="editConfigInfo"
                @my-submit="editConfig"/>

        <message-box
                ref="message"
                title="启用确认"
                @my-cancel="$event()"
                @my-submit="submitFunc">
            <div class="el-message-box__content">
                <div class="el-message-box__status el-icon-warning"></div>
                <div class="el-message-box__message"><p>{{message.text}}</p></div>
            </div>
            <div>
                <el-checkbox v-model="message.checked" style="margin-left: 50px">启用该账号子账号</el-checkbox>
            </div>
        </message-box>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import messageBox from 'components/messageBox'
    import compAddAccount from './compAddAccount'
    import compEditAccount from './compEditAccount'
    import compAccessConfiguration from './compAccessConfiguration'

    export default {
        components: {
            messageBox,
            compAddAccount,
            compEditAccount,
            compAccessConfiguration
        },
        data() {
            return {
                loading: false,
                authTypeCode: 'PLATFORM',
                userAuthTypeCode: '',// 当前账号角色
                currentPage: 1,
                editInfo: {},
                showEdit: false,
                message: {
                    text: '是否确认启用账号XXX？',
                    checked: false
                },
                enableUserId: '',//将要启用的账户id
                editConfigUserId: '',//权限配置的账户id
                editConfigInfo: [],
            }
        },
        computed: {
            ...mapState('authUsers', ['listUsers'])
        },
        created() {
            // 判断是否有分组功能
            this.userAuthTypeCode = localStorage.getItem('authTypeCode');
            if (this.userAuthTypeCode === 'OPERATION') {
                this.authTypeCode = 'OPERATION'
            }

            this.getList()
        },
        methods: {
            ...mapActions('authUsers', ['getListUsers', 'createUser', 'updateUser', 'deleteUser', 'disableUser', 'hasDisableAncestor', 'enableUser', 'getPermissions', 'updatePermissions']),
            getList(obj = {}) {
                this.loading = true;
                let params = {
                    authTypeCode: this.authTypeCode,
                    page: 1
                };
                Object.assign(params, obj);

                this.currentPage = params.page;
                this.getListUsers(params).then(() => {
                    this.loading = false;
                    if (this.currentPage !== 1 && !this.listUsers.beanList.length) {
                        this.getList(this.currentPage - 1)
                    }
                })
            },
            addUser({value, cb}) {
                let params = value;
                params.authTypeCode = this.authTypeCode;
                this.createUser(params).then(() => {
                    cb();
                    this.$message.success('创建成功');
                    this.getList()
                })
            },
            clickEdit(row) {
                this.$refs.edit.show = true;
                this.editInfo = Object.assign({}, this.editInfo, row);
            },
            editUser({value, cb}) {
                this.updateUser(value).then(() => {
                    cb();
                    this.$message.success('保存成功');
                    this.getList({page: this.currentPage})
                })
            },
            removeUser({id, cb}) {
                this.deleteUser({userId: id}).then(() => {
                    cb();
                    this.$message.success('删除成功');
                    this.getList({page: this.currentPage})
                })
            },
            changeStatus(row, value) {
                if (!value) {
                    this.$confirm(`是否确认停用账号${row.username}，停用后该账号创建的子账号将一并停用，请谨慎操作。`, '停用确认', {
                        cancelButtonText: '取消',
                        confirmButtonText: '确认',
                        type: 'warning'
                    }).then(() => {
                        this.disableUser({userId: row.id}).then(() => {
                            this.getList({page: this.currentPage});
                            this.$message.success('修改成功');
                        })
                    }).catch(() => {

                    })
                } else {
                    this.hasDisableAncestor({userId: row.id}).then(res => {
                        if (res.hasDisableAncestor && res.disableAncestorCount) {
                            this.message.text = `该账号的父账号未启用，是否确认启用该账号${row.username}？启用后父账号也将启用。`
                        } else {
                            this.message.text = `是否确认启用账号${row.username}？`
                        }
                        this.enableUserId = row.id;
                        this.$refs.message.show = true;
                    })
                }
            },
            // 状态 启用账户
            submitFunc(e) {
                this.enableUser({
                    enableChild: this.message.checked,
                    enableParent: true,
                    userId: this.enableUserId
                }).then(() => {
                    this.$message.success('修改成功');
                    this.enableUserId = '';
                    this.getList({page: this.currentPage});
                    e();
                })
            },
            // 获取权限列表
            getConfig(id) {
                this.editConfigUserId = id;
                this.getPermissions({userId: id}).then(res => {
                    this.editConfigInfo = res.data;
                    this.$refs.config.show = true;
                });
            },
            // 权限配置
            editConfig({value, cb}) {
                this.updatePermissions({
                    userId: this.editConfigUserId,
                    permissionIds: value
                }).then(() => {
                    this.$message.success('保存成功');
                    cb();
                    this.getList({page: this.currentPage});
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .edit-icon {
        color: $theme-color;
        cursor: pointer;
    }
</style>